export const getDefinedValues = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj)
      .filter(
        ([, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(([key, value]) => [
        key,
        typeof value === "object" && !Array.isArray(value)
          ? getDefinedValues(value)
          : value,
      ])
  );
